document.addEventListener('DOMContentLoaded', function() {
  document.querySelector(".cstm-login").addEventListener('click', function() {
    
    document.querySelector(".cstm-login-popup").style.display = "block"
  });

   document.querySelector(".cstm-login-pop-overlay ").addEventListener('click', function() {
    
    document.querySelector(".cstm-login-popup").style.display = "none"
  });

   document.querySelector(".cstm-login-close-btn").addEventListener('click', function() {
    
    document.querySelector(".cstm-login-popup").style.display = "none"
  });
   document.querySelector(".cstm-overlay-signup").addEventListener('click', function() {
    
    document.querySelector(".cstm-signup-popup").style.display = "none"
  });

  
  
  
   document.querySelector(".cstm-sign-btn").addEventListener('click', function() {
    
    document.querySelector(".cstm-signup-popup").style.display = "block"
  });

   document.querySelector(".cstm-sign-close-btn").addEventListener('click', function() {
    
    document.querySelector(".cstm-signup-popup").style.display = "none"
  });
document.querySelector(".cstm-popup-login-open").addEventListener('click', function(e) {
  e.preventDefault();
   document.querySelector(".cstm-login-popup").style.display = "none"
     document.querySelector(".cstm-signup-popup").style.display = "block"
  });

document.querySelector(".cstm-login-open").addEventListener('click', function(e) {
  e.preventDefault();
  document.querySelector(".cstm-signup-popup").style.display = "none"
   document.querySelector(".cstm-login-popup").style.display = "block"
     
  });
  
  
});
